import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "lpu-cards-filters-toggle-item d-flex align-center justify-space-between ga-4 px-4 py-2",
      class: { "lpu-cards-filters-toggle-item--readonly": _vm.readonly },
      attrs: { "data-qa": _vm.itemDataQa },
      on: { click: _setup.handleRowClick },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center ga-4 min-w-0" },
        [
          _c(VIcon, { attrs: { size: "24", color: "icon-secondary" } }, [
            _vm._v("\n      " + _vm._s(_vm.icon) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-1 text--text" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(VSwitch, {
        staticClass:
          "lpu-cards-filters-toggle-item__switch pt-0 mt-0 flex-shrink-0",
        attrs: {
          "input-value": _vm.value,
          color: "primary",
          "hide-details": "",
          dense: "",
          inset: "",
          readonly: _vm.readonly,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
          change: _setup.handleSwitchChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }